export default __webpack_public_path__ + "static/media/Facilities-CACS-23.67ef40de.jpg";